<template>
  <div>
    <div class="privates" v-if="list.length > 0">
      <div
        class="private_item"
        :class="{ divborder: showIndex == index }"
        v-for="(item, index) in list"
        :key="item.user_id"
        :data-index="index"
        @click="handleTap(item.user_id, index)"
      >
        <div class="private_avatar">
          <img :src="item.user_avatar" />
        </div>
        <div class="privatesCon">
          <div class="private_content">
            <div class="private_name">我是{{ item.user_nick }}</div>
            <div class="private_msg">
              {{ item.message }}
            </div>
          </div>
          <div class="private_right">
            <div class="private_time">
              {{ item.time }}
            </div>
            <div class="private_msg_num" v-if="item.noread_count !== 0">
              {{ item.noread_count }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="privates privates_empty" v-else>
      <van-empty
        class="custom-image"
        description="暂无内容"
        image="http://img.wish.hebyun.com.cn/images/empty_state.png"
      />
    </div>
    <div class="side_bars">
      <img
        src="http://img.wish.hebyun.com.cn/images/return_con.png"
        @click="goback"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "myprivate",
  components: {},
  data() {
    return {
      current: 0,
      list: [],
      showIndex: -1,
    };
  },
  created() {
    this.queryChatList();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    handleTap(id, index) {
      this.isDologin = true;
      this.showIndex = index;
      setTimeout(() => {
        this.$router.push({
          path: "/privateDetail",
          query: { id: id },
        });
      }, 250);
    },

    // 聊天列表
    async queryChatList() {
      let { data } = await this.$api.queryChatList();
      this.list = data;
    },
  },
};
</script>
<style scoped lang="scss">
.privates_empty {
  display: flex;
  align-items: center;
  justify-content: center;
}
.privates {
  margin: 0;
  padding: 0;
  width: 100%;
  height: auto;
  min-height: 100vh;
  background-color: #f9f1c6;
  padding-bottom: 25px;
  box-sizing: border-box;

  .private_item {
    display: flex;
    width: 100%;
    align-items: center;
    padding: 10px 14px;
    box-sizing: border-box;
    .private_avatar {
      width: 53px;
      height: 53px;
      background-color: #f5f5f5;
      box-shadow: 0px 0.5px 1px 0px rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      overflow: hidden;
      margin-right: 12px;
      img {
        width: 53px;
        height: 53px;
      }
    }
    .privatesCon {
      width: calc(100% - 80px);
      padding: 12px 0;
      border-bottom: 1px solid rgba(229, 0, 18, 0.1);
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .private_content {
        flex: 1;
        overflow: hidden;
        .private_name {
          font-size: 15px;
          color: #333333;
          text-align: left;
        }
        .private_msg {
          font-size: 12px;
          color: #666666;
          overflow: hidden;
          width: 100%;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;
        }
      }

      .private_right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        width: 80px;
        .private_time {
          font-size: 12px;
          color: #666666;
        }
        .private_msg_num {
          width: 13px;
          height: 13px;
          background-color: #ff0000;
          font-size: 10px;
          line-height: 13px;
          color: #ffffff;
          text-align: center;
          border-radius: 50%;
          margin-top: 4px;
        }
      }
    }
  }
  .private_item.divborder {
    background-color: #fff;
  }
}

.isClick {
  background-color: #fff;
}
</style>
<style lang="scss">
// 侧边功能区
.side_bars {
  position: fixed;
  right: -5px;
  bottom: 320px;
  z-index: 10000;
  img {
    display: block;
    width: 45px;
    height: 45px;
    margin-bottom: 7px;
  }
}
</style>
